module.exports = __webpack_public_path__ + "static/img/1_2.333c94e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/1_2.jpg
// module id = TVwO
// module chunks = 0